import React from 'react'
import { Card, CardActions, CardContent, CardHeader } from '@material-ui/core'

const JumboCardWrapper = ({ children, ...overrides }) => {
  const jumboCardConfig = {
    display: 'flex',
    flexDirection: 'column',
    header: true,
    list: true,
    ...overrides
  }

  const { flexDirection, header, list, headerActions, cardActions, ...remainingJumboCardConfig } =
    jumboCardConfig

  const cardOrientation = flexDirection
  const hasHeader = header
  const isList = list
  const headerAvatar = jumboCardConfig.avatar
  const headerTitle = jumboCardConfig.title
  const subHeaderTitle = jumboCardConfig.subheader
  const headerStyle = jumboCardConfig.headerStyle

  // default for card component
  if (cardOrientation === 'row') {
    return (
      <Card {...remainingJumboCardConfig}>
        {hasHeader && <CardHeader avatar={headerAvatar} title={headerTitle} style={headerStyle}/>}
        <CardContent>{children}</CardContent>
        {cardActions && <CardActions>{cardActions}</CardActions>}
      </Card>
    )
  }

  // default for side panel component
  if (cardOrientation === 'column') {
    return (
      <Card
        {...remainingJumboCardConfig}
        className={`SidepanelContainer ${
          isList ? 'SidepanelContainerList' : 'SidepanelContainerInfo'
        }`}
      >
        {hasHeader && (
          <CardHeader
            action={headerActions && <CardActions>{headerActions}</CardActions>}
            avatar={headerAvatar}
            className='SidepanelHeader'
            title={headerTitle}
            subheader={subHeaderTitle}
            style={headerStyle}
          />
        )}
        <CardContent className='SidepanelContent'>{children}</CardContent>
        {cardActions && <CardActions>{cardActions}</CardActions>}
      </Card>
    )
  }

  // default base component
  return (
    <Card {...remainingJumboCardConfig}>
      {hasHeader && <CardHeader avatar={headerAvatar} title={headerTitle} style={headerStyle}/>}
      <CardContent>{children}</CardContent>
      {cardActions && <CardActions>{cardActions}</CardActions>}
    </Card>
  )
}

export default JumboCardWrapper
